import * as React from 'react';

import {GridList} from './grid-list';

import styles from './feature-card-grid.module.css';

type Props<T> = {
    items: T[];
    renderCard: (item: T) => React.ReactElement<any>;
    hasIllustration: (item: T) => boolean;
    getKey: (item: T) => string;
    numColumns?: number;
    illustrationPosition?: 'left' | 'right';
};

export function FeatureCardGrid<T>(props: Props<T>) {
    const {numColumns = 4, illustrationPosition = 'left'} = props;

    const renderCards = () =>
        props.items.map((item) => {
            const card = props.renderCard(item);
            const key = props.getKey(item);

            if (props.hasIllustration(item)) {
                const illustrationStyleName =
                    illustrationPosition === 'right'
                        ? styles['card--with-illustration-right']
                        : styles['card--with-illustration'];

                return (
                    <div key={key} className={illustrationStyleName}>
                        {card}
                    </div>
                );
            }

            return React.cloneElement(card, {key});
        });

    // Use custom grid with dense packing for right-positioned illustrations
    if (illustrationPosition === 'right') {
        return <div className={styles['grid-right-illustration']}>{renderCards()}</div>;
    }

    return <GridList numColumns={numColumns}>{renderCards()}</GridList>;
}
